module.exports = __webpack_public_path__ + "img/screenshotComingSoon.7f5c1199.jpg";